var cov_1hsdzkih27 = function () {
  var path = '/opt/lampp/htdocs/www/omcg/apps/delta-monitoring/client/src/assets/js/plugins/venobox.min.js',
      hash = '06ea71500a57d9b9794dfec533bf22605b1d71ae',
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = '__coverage__',
      coverageData = {
    path: '/opt/lampp/htdocs/www/omcg/apps/delta-monitoring/client/src/assets/js/plugins/venobox.min.js',
    statementMap: {
      '0': {
        start: {
          line: 12,
          column: 0
        },
        end: {
          line: 12,
          column: 14733
        }
      },
      '1': {
        start: {
          line: 12,
          column: 126
        },
        end: {
          line: 12,
          column: 1007
        }
      },
      '2': {
        start: {
          line: 12,
          column: 1010
        },
        end: {
          line: 12,
          column: 1307
        }
      },
      '3': {
        start: {
          line: 12,
          column: 1310
        },
        end: {
          line: 12,
          column: 1968
        }
      },
      '4': {
        start: {
          line: 12,
          column: 1971
        },
        end: {
          line: 12,
          column: 2380
        }
      },
      '5': {
        start: {
          line: 12,
          column: 2383
        },
        end: {
          line: 12,
          column: 2619
        }
      },
      '6': {
        start: {
          line: 12,
          column: 2620
        },
        end: {
          line: 12,
          column: 14723
        }
      },
      '7': {
        start: {
          line: 12,
          column: 2660
        },
        end: {
          line: 12,
          column: 2664
        }
      },
      '8': {
        start: {
          line: 12,
          column: 2668
        },
        end: {
          line: 12,
          column: 3436
        }
      },
      '9': {
        start: {
          line: 12,
          column: 3230
        },
        end: {
          line: 12,
          column: 3238
        }
      },
      '10': {
        start: {
          line: 12,
          column: 3290
        },
        end: {
          line: 12,
          column: 3298
        }
      },
      '11': {
        start: {
          line: 12,
          column: 3437
        },
        end: {
          line: 12,
          column: 14720
        }
      },
      '12': {
        start: {
          line: 12,
          column: 3480
        },
        end: {
          line: 12,
          column: 3520
        }
      },
      '13': {
        start: {
          line: 12,
          column: 3511
        },
        end: {
          line: 12,
          column: 3520
        }
      },
      '14': {
        start: {
          line: 12,
          column: 3533
        },
        end: {
          line: 12,
          column: 4870
        }
      },
      '15': {
        start: {
          line: 12,
          column: 4322
        },
        end: {
          line: 12,
          column: 4336
        }
      },
      '16': {
        start: {
          line: 12,
          column: 4886
        },
        end: {
          line: 12,
          column: 5673
        }
      },
      '17': {
        start: {
          line: 12,
          column: 5325
        },
        end: {
          line: 12,
          column: 5669
        }
      },
      '18': {
        start: {
          line: 12,
          column: 5689
        },
        end: {
          line: 12,
          column: 5767
        }
      },
      '19': {
        start: {
          line: 12,
          column: 5782
        },
        end: {
          line: 12,
          column: 5824
        }
      },
      '20': {
        start: {
          line: 12,
          column: 5815
        },
        end: {
          line: 12,
          column: 5824
        }
      },
      '21': {
        start: {
          line: 12,
          column: 5824
        },
        end: {
          line: 12,
          column: 5960
        }
      },
      '22': {
        start: {
          line: 12,
          column: 5924
        },
        end: {
          line: 12,
          column: 5958
        }
      },
      '23': {
        start: {
          line: 12,
          column: 5961
        },
        end: {
          line: 12,
          column: 11373
        }
      },
      '24': {
        start: {
          line: 12,
          column: 5983
        },
        end: {
          line: 12,
          column: 5987
        }
      },
      '25': {
        start: {
          line: 12,
          column: 6385
        },
        end: {
          line: 12,
          column: 6449
        }
      },
      '26': {
        start: {
          line: 12,
          column: 6440
        },
        end: {
          line: 12,
          column: 6449
        }
      },
      '27': {
        start: {
          line: 12,
          column: 6449
        },
        end: {
          line: 12,
          column: 9518
        }
      },
      '28': {
        start: {
          line: 12,
          column: 6486
        },
        end: {
          line: 12,
          column: 6491
        }
      },
      '29': {
        start: {
          line: 12,
          column: 6514
        },
        end: {
          line: 12,
          column: 6519
        }
      },
      '30': {
        start: {
          line: 12,
          column: 6871
        },
        end: {
          line: 12,
          column: 6914
        }
      },
      '31': {
        start: {
          line: 12,
          column: 6914
        },
        end: {
          line: 12,
          column: 6920
        }
      },
      '32': {
        start: {
          line: 12,
          column: 6940
        },
        end: {
          line: 12,
          column: 7074
        }
      },
      '33': {
        start: {
          line: 12,
          column: 7074
        },
        end: {
          line: 12,
          column: 7080
        }
      },
      '34': {
        start: {
          line: 12,
          column: 7091
        },
        end: {
          line: 12,
          column: 7304
        }
      },
      '35': {
        start: {
          line: 12,
          column: 7304
        },
        end: {
          line: 12,
          column: 7310
        }
      },
      '36': {
        start: {
          line: 12,
          column: 7332
        },
        end: {
          line: 12,
          column: 7448
        }
      },
      '37': {
        start: {
          line: 12,
          column: 7448
        },
        end: {
          line: 12,
          column: 7454
        }
      },
      '38': {
        start: {
          line: 12,
          column: 7474
        },
        end: {
          line: 12,
          column: 7527
        }
      },
      '39': {
        start: {
          line: 12,
          column: 7527
        },
        end: {
          line: 12,
          column: 7533
        }
      },
      '40': {
        start: {
          line: 12,
          column: 7552
        },
        end: {
          line: 12,
          column: 7665
        }
      },
      '41': {
        start: {
          line: 12,
          column: 7665
        },
        end: {
          line: 12,
          column: 7671
        }
      },
      '42': {
        start: {
          line: 12,
          column: 7690
        },
        end: {
          line: 12,
          column: 7848
        }
      },
      '43': {
        start: {
          line: 12,
          column: 7848
        },
        end: {
          line: 12,
          column: 7854
        }
      },
      '44': {
        start: {
          line: 12,
          column: 7867
        },
        end: {
          line: 12,
          column: 8373
        }
      },
      '45': {
        start: {
          line: 12,
          column: 8373
        },
        end: {
          line: 12,
          column: 8379
        }
      },
      '46': {
        start: {
          line: 12,
          column: 8395
        },
        end: {
          line: 12,
          column: 8757
        }
      },
      '47': {
        start: {
          line: 12,
          column: 8757
        },
        end: {
          line: 12,
          column: 8763
        }
      },
      '48': {
        start: {
          line: 12,
          column: 8783
        },
        end: {
          line: 12,
          column: 9308
        }
      },
      '49': {
        start: {
          line: 12,
          column: 9308
        },
        end: {
          line: 12,
          column: 9314
        }
      },
      '50': {
        start: {
          line: 12,
          column: 9333
        },
        end: {
          line: 12,
          column: 9517
        }
      },
      '51': {
        start: {
          line: 12,
          column: 9518
        },
        end: {
          line: 12,
          column: 11370
        }
      },
      '52': {
        start: {
          line: 12,
          column: 11066
        },
        end: {
          line: 12,
          column: 11251
        }
      },
      '53': {
        start: {
          line: 12,
          column: 11314
        },
        end: {
          line: 12,
          column: 11319
        }
      },
      '54': {
        start: {
          line: 12,
          column: 11360
        },
        end: {
          line: 12,
          column: 11365
        }
      },
      '55': {
        start: {
          line: 12,
          column: 11380
        },
        end: {
          line: 12,
          column: 11395
        }
      },
      '56': {
        start: {
          line: 12,
          column: 11411
        },
        end: {
          line: 12,
          column: 11467
        }
      },
      '57': {
        start: {
          line: 12,
          column: 11483
        },
        end: {
          line: 12,
          column: 11611
        }
      },
      '58': {
        start: {
          line: 12,
          column: 11494
        },
        end: {
          line: 12,
          column: 11526
        }
      },
      '59': {
        start: {
          line: 12,
          column: 11532
        },
        end: {
          line: 12,
          column: 11543
        }
      },
      '60': {
        start: {
          line: 12,
          column: 11544
        },
        end: {
          line: 12,
          column: 11610
        }
      },
      '61': {
        start: {
          line: 12,
          column: 11627
        },
        end: {
          line: 12,
          column: 11781
        }
      },
      '62': {
        start: {
          line: 12,
          column: 11638
        },
        end: {
          line: 12,
          column: 11643
        }
      },
      '63': {
        start: {
          line: 12,
          column: 11649
        },
        end: {
          line: 12,
          column: 11650
        }
      },
      '64': {
        start: {
          line: 12,
          column: 11653
        },
        end: {
          line: 12,
          column: 11655
        }
      },
      '65': {
        start: {
          line: 12,
          column: 11656
        },
        end: {
          line: 12,
          column: 11780
        }
      },
      '66': {
        start: {
          line: 12,
          column: 11782
        },
        end: {
          line: 12,
          column: 12063
        }
      },
      '67': {
        start: {
          line: 12,
          column: 11865
        },
        end: {
          line: 12,
          column: 12038
        }
      },
      '68': {
        start: {
          line: 12,
          column: 12070
        },
        end: {
          line: 12,
          column: 12133
        }
      },
      '69': {
        start: {
          line: 12,
          column: 12137
        },
        end: {
          line: 12,
          column: 12345
        }
      },
      '70': {
        start: {
          line: 12,
          column: 12155
        },
        end: {
          line: 12,
          column: 12292
        }
      },
      '71': {
        start: {
          line: 12,
          column: 12186
        },
        end: {
          line: 12,
          column: 12196
        }
      },
      '72': {
        start: {
          line: 12,
          column: 12196
        },
        end: {
          line: 12,
          column: 12202
        }
      },
      '73': {
        start: {
          line: 12,
          column: 12231
        },
        end: {
          line: 12,
          column: 12239
        }
      },
      '74': {
        start: {
          line: 12,
          column: 12239
        },
        end: {
          line: 12,
          column: 12245
        }
      },
      '75': {
        start: {
          line: 12,
          column: 12261
        },
        end: {
          line: 12,
          column: 12271
        }
      },
      '76': {
        start: {
          line: 12,
          column: 12271
        },
        end: {
          line: 12,
          column: 12277
        }
      },
      '77': {
        start: {
          line: 12,
          column: 12285
        },
        end: {
          line: 12,
          column: 12291
        }
      },
      '78': {
        start: {
          line: 12,
          column: 12298
        },
        end: {
          line: 12,
          column: 12321
        }
      },
      '79': {
        start: {
          line: 12,
          column: 12322
        },
        end: {
          line: 12,
          column: 12344
        }
      },
      '80': {
        start: {
          line: 12,
          column: 12349
        },
        end: {
          line: 12,
          column: 12602
        }
      },
      '81': {
        start: {
          line: 12,
          column: 12367
        },
        end: {
          line: 12,
          column: 12491
        }
      },
      '82': {
        start: {
          line: 12,
          column: 12399
        },
        end: {
          line: 12,
          column: 12409
        }
      },
      '83': {
        start: {
          line: 12,
          column: 12409
        },
        end: {
          line: 12,
          column: 12415
        }
      },
      '84': {
        start: {
          line: 12,
          column: 12430
        },
        end: {
          line: 12,
          column: 12438
        }
      },
      '85': {
        start: {
          line: 12,
          column: 12438
        },
        end: {
          line: 12,
          column: 12444
        }
      },
      '86': {
        start: {
          line: 12,
          column: 12460
        },
        end: {
          line: 12,
          column: 12470
        }
      },
      '87': {
        start: {
          line: 12,
          column: 12470
        },
        end: {
          line: 12,
          column: 12476
        }
      },
      '88': {
        start: {
          line: 12,
          column: 12484
        },
        end: {
          line: 12,
          column: 12490
        }
      },
      '89': {
        start: {
          line: 12,
          column: 12499
        },
        end: {
          line: 12,
          column: 12525
        }
      },
      '90': {
        start: {
          line: 12,
          column: 12526
        },
        end: {
          line: 12,
          column: 12601
        }
      },
      '91': {
        start: {
          line: 12,
          column: 12606
        },
        end: {
          line: 12,
          column: 12676
        }
      },
      '92': {
        start: {
          line: 12,
          column: 12624
        },
        end: {
          line: 12,
          column: 12675
        }
      },
      '93': {
        start: {
          line: 12,
          column: 12691
        },
        end: {
          line: 12,
          column: 12893
        }
      },
      '94': {
        start: {
          line: 12,
          column: 12733
        },
        end: {
          line: 12,
          column: 12784
        }
      },
      '95': {
        start: {
          line: 12,
          column: 12803
        },
        end: {
          line: 12,
          column: 12891
        }
      },
      '96': {
        start: {
          line: 12,
          column: 12908
        },
        end: {
          line: 12,
          column: 12970
        }
      },
      '97': {
        start: {
          line: 12,
          column: 12994
        },
        end: {
          line: 12,
          column: 13286
        }
      },
      '98': {
        start: {
          line: 12,
          column: 13012
        },
        end: {
          line: 12,
          column: 13255
        }
      },
      '99': {
        start: {
          line: 12,
          column: 13255
        },
        end: {
          line: 12,
          column: 13282
        }
      },
      '100': {
        start: {
          line: 12,
          column: 13289
        },
        end: {
          line: 12,
          column: 13508
        }
      },
      '101': {
        start: {
          line: 12,
          column: 13340
        },
        end: {
          line: 12,
          column: 13342
        }
      },
      '102': {
        start: {
          line: 12,
          column: 13345
        },
        end: {
          line: 12,
          column: 13377
        }
      },
      '103': {
        start: {
          line: 12,
          column: 13378
        },
        end: {
          line: 12,
          column: 13485
        }
      },
      '104': {
        start: {
          line: 12,
          column: 13406
        },
        end: {
          line: 12,
          column: 13421
        }
      },
      '105': {
        start: {
          line: 12,
          column: 13422
        },
        end: {
          line: 12,
          column: 13484
        }
      },
      '106': {
        start: {
          line: 12,
          column: 13445
        },
        end: {
          line: 12,
          column: 13484
        }
      },
      '107': {
        start: {
          line: 12,
          column: 13485
        },
        end: {
          line: 12,
          column: 13504
        }
      },
      '108': {
        start: {
          line: 12,
          column: 13509
        },
        end: {
          line: 12,
          column: 13782
        }
      },
      '109': {
        start: {
          line: 12,
          column: 13797
        },
        end: {
          line: 12,
          column: 13858
        }
      },
      '110': {
        start: {
          line: 12,
          column: 13873
        },
        end: {
          line: 12,
          column: 13959
        }
      },
      '111': {
        start: {
          line: 12,
          column: 13916
        },
        end: {
          line: 12,
          column: 13952
        }
      },
      '112': {
        start: {
          line: 12,
          column: 13946
        },
        end: {
          line: 12,
          column: 13950
        }
      },
      '113': {
        start: {
          line: 12,
          column: 13974
        },
        end: {
          line: 12,
          column: 14250
        }
      },
      '114': {
        start: {
          line: 12,
          column: 14127
        },
        end: {
          line: 12,
          column: 14145
        }
      },
      '115': {
        start: {
          line: 12,
          column: 14210
        },
        end: {
          line: 12,
          column: 14218
        }
      },
      '116': {
        start: {
          line: 12,
          column: 14271
        },
        end: {
          line: 12,
          column: 14286
        }
      },
      '117': {
        start: {
          line: 12,
          column: 14289
        },
        end: {
          line: 12,
          column: 14307
        }
      },
      '118': {
        start: {
          line: 12,
          column: 14308
        },
        end: {
          line: 12,
          column: 14398
        }
      },
      '119': {
        start: {
          line: 12,
          column: 14399
        },
        end: {
          line: 12,
          column: 14718
        }
      },
      '120': {
        start: {
          line: 12,
          column: 14669
        },
        end: {
          line: 12,
          column: 14716
        }
      }
    },
    fnMap: {
      '0': {
        name: '(anonymous_0)',
        decl: {
          start: {
            line: 12,
            column: 1
          },
          end: {
            line: 12,
            column: 2
          }
        },
        loc: {
          start: {
            line: 12,
            column: 12
          },
          end: {
            line: 12,
            column: 14724
          }
        },
        line: 12
      },
      '1': {
        name: '(anonymous_1)',
        decl: {
          start: {
            line: 12,
            column: 2641
          },
          end: {
            line: 12,
            column: 2642
          }
        },
        loc: {
          start: {
            line: 12,
            column: 2652
          },
          end: {
            line: 12,
            column: 14721
          }
        },
        line: 12
      },
      '2': {
        name: '(anonymous_2)',
        decl: {
          start: {
            line: 12,
            column: 3219
          },
          end: {
            line: 12,
            column: 3220
          }
        },
        loc: {
          start: {
            line: 12,
            column: 3229
          },
          end: {
            line: 12,
            column: 3239
          }
        },
        line: 12
      },
      '3': {
        name: '(anonymous_3)',
        decl: {
          start: {
            line: 12,
            column: 3253
          },
          end: {
            line: 12,
            column: 3254
          }
        },
        loc: {
          start: {
            line: 12,
            column: 3263
          },
          end: {
            line: 12,
            column: 3265
          }
        },
        line: 12
      },
      '4': {
        name: '(anonymous_4)',
        decl: {
          start: {
            line: 12,
            column: 3279
          },
          end: {
            line: 12,
            column: 3280
          }
        },
        loc: {
          start: {
            line: 12,
            column: 3289
          },
          end: {
            line: 12,
            column: 3299
          }
        },
        line: 12
      },
      '5': {
        name: '(anonymous_5)',
        decl: {
          start: {
            line: 12,
            column: 3314
          },
          end: {
            line: 12,
            column: 3315
          }
        },
        loc: {
          start: {
            line: 12,
            column: 3324
          },
          end: {
            line: 12,
            column: 3326
          }
        },
        line: 12
      },
      '6': {
        name: '(anonymous_6)',
        decl: {
          start: {
            line: 12,
            column: 3342
          },
          end: {
            line: 12,
            column: 3343
          }
        },
        loc: {
          start: {
            line: 12,
            column: 3352
          },
          end: {
            line: 12,
            column: 3354
          }
        },
        line: 12
      },
      '7': {
        name: '(anonymous_7)',
        decl: {
          start: {
            line: 12,
            column: 3368
          },
          end: {
            line: 12,
            column: 3369
          }
        },
        loc: {
          start: {
            line: 12,
            column: 3378
          },
          end: {
            line: 12,
            column: 3380
          }
        },
        line: 12
      },
      '8': {
        name: '(anonymous_8)',
        decl: {
          start: {
            line: 12,
            column: 3399
          },
          end: {
            line: 12,
            column: 3400
          }
        },
        loc: {
          start: {
            line: 12,
            column: 3409
          },
          end: {
            line: 12,
            column: 3411
          }
        },
        line: 12
      },
      '9': {
        name: '(anonymous_9)',
        decl: {
          start: {
            line: 12,
            column: 3420
          },
          end: {
            line: 12,
            column: 3421
          }
        },
        loc: {
          start: {
            line: 12,
            column: 3430
          },
          end: {
            line: 12,
            column: 3432
          }
        },
        line: 12
      },
      '10': {
        name: '(anonymous_10)',
        decl: {
          start: {
            line: 12,
            column: 3469
          },
          end: {
            line: 12,
            column: 3470
          }
        },
        loc: {
          start: {
            line: 12,
            column: 3479
          },
          end: {
            line: 12,
            column: 14719
          }
        },
        line: 12
      },
      '11': {
        name: 'L',
        decl: {
          start: {
            line: 12,
            column: 3529
          },
          end: {
            line: 12,
            column: 3530
          }
        },
        loc: {
          start: {
            line: 12,
            column: 3532
          },
          end: {
            line: 12,
            column: 4871
          }
        },
        line: 12
      },
      '12': {
        name: '(anonymous_12)',
        decl: {
          start: {
            line: 12,
            column: 4308
          },
          end: {
            line: 12,
            column: 4309
          }
        },
        loc: {
          start: {
            line: 12,
            column: 4321
          },
          end: {
            line: 12,
            column: 4337
          }
        },
        line: 12
      },
      '13': {
        name: 'ie',
        decl: {
          start: {
            line: 12,
            column: 4880
          },
          end: {
            line: 12,
            column: 4882
          }
        },
        loc: {
          start: {
            line: 12,
            column: 4885
          },
          end: {
            line: 12,
            column: 5674
          }
        },
        line: 12
      },
      '14': {
        name: '(anonymous_14)',
        decl: {
          start: {
            line: 12,
            column: 5314
          },
          end: {
            line: 12,
            column: 5315
          }
        },
        loc: {
          start: {
            line: 12,
            column: 5324
          },
          end: {
            line: 12,
            column: 5670
          }
        },
        line: 12
      },
      '15': {
        name: 'ae',
        decl: {
          start: {
            line: 12,
            column: 5683
          },
          end: {
            line: 12,
            column: 5685
          }
        },
        loc: {
          start: {
            line: 12,
            column: 5688
          },
          end: {
            line: 12,
            column: 5768
          }
        },
        line: 12
      },
      '16': {
        name: 'te',
        decl: {
          start: {
            line: 12,
            column: 5777
          },
          end: {
            line: 12,
            column: 5779
          }
        },
        loc: {
          start: {
            line: 12,
            column: 5781
          },
          end: {
            line: 12,
            column: 5961
          }
        },
        line: 12
      },
      '17': {
        name: '(anonymous_17)',
        decl: {
          start: {
            line: 12,
            column: 5913
          },
          end: {
            line: 12,
            column: 5914
          }
        },
        loc: {
          start: {
            line: 12,
            column: 5923
          },
          end: {
            line: 12,
            column: 5959
          }
        },
        line: 12
      },
      '18': {
        name: '(anonymous_18)',
        decl: {
          start: {
            line: 12,
            column: 5972
          },
          end: {
            line: 12,
            column: 5973
          }
        },
        loc: {
          start: {
            line: 12,
            column: 5982
          },
          end: {
            line: 12,
            column: 5988
          }
        },
        line: 12
      },
      '19': {
        name: '(anonymous_19)',
        decl: {
          start: {
            line: 12,
            column: 6373
          },
          end: {
            line: 12,
            column: 6374
          }
        },
        loc: {
          start: {
            line: 12,
            column: 6384
          },
          end: {
            line: 12,
            column: 11371
          }
        },
        line: 12
      },
      '20': {
        name: '(anonymous_20)',
        decl: {
          start: {
            line: 12,
            column: 6475
          },
          end: {
            line: 12,
            column: 6476
          }
        },
        loc: {
          start: {
            line: 12,
            column: 6485
          },
          end: {
            line: 12,
            column: 6492
          }
        },
        line: 12
      },
      '21': {
        name: '(anonymous_21)',
        decl: {
          start: {
            line: 12,
            column: 6503
          },
          end: {
            line: 12,
            column: 6504
          }
        },
        loc: {
          start: {
            line: 12,
            column: 6513
          },
          end: {
            line: 12,
            column: 6520
          }
        },
        line: 12
      },
      '22': {
        name: '(anonymous_22)',
        decl: {
          start: {
            line: 12,
            column: 11055
          },
          end: {
            line: 12,
            column: 11056
          }
        },
        loc: {
          start: {
            line: 12,
            column: 11065
          },
          end: {
            line: 12,
            column: 11252
          }
        },
        line: 12
      },
      '23': {
        name: '(anonymous_23)',
        decl: {
          start: {
            line: 12,
            column: 11303
          },
          end: {
            line: 12,
            column: 11304
          }
        },
        loc: {
          start: {
            line: 12,
            column: 11313
          },
          end: {
            line: 12,
            column: 11320
          }
        },
        line: 12
      },
      '24': {
        name: '(anonymous_24)',
        decl: {
          start: {
            line: 12,
            column: 11349
          },
          end: {
            line: 12,
            column: 11350
          }
        },
        loc: {
          start: {
            line: 12,
            column: 11359
          },
          end: {
            line: 12,
            column: 11366
          }
        },
        line: 12
      },
      '25': {
        name: 'ce',
        decl: {
          start: {
            line: 12,
            column: 11405
          },
          end: {
            line: 12,
            column: 11407
          }
        },
        loc: {
          start: {
            line: 12,
            column: 11410
          },
          end: {
            line: 12,
            column: 11468
          }
        },
        line: 12
      },
      '26': {
        name: 're',
        decl: {
          start: {
            line: 12,
            column: 11477
          },
          end: {
            line: 12,
            column: 11479
          }
        },
        loc: {
          start: {
            line: 12,
            column: 11482
          },
          end: {
            line: 12,
            column: 11612
          }
        },
        line: 12
      },
      '27': {
        name: 'le',
        decl: {
          start: {
            line: 12,
            column: 11621
          },
          end: {
            line: 12,
            column: 11623
          }
        },
        loc: {
          start: {
            line: 12,
            column: 11626
          },
          end: {
            line: 12,
            column: 11782
          }
        },
        line: 12
      },
      '28': {
        name: '(anonymous_28)',
        decl: {
          start: {
            line: 12,
            column: 11853
          },
          end: {
            line: 12,
            column: 11854
          }
        },
        loc: {
          start: {
            line: 12,
            column: 11864
          },
          end: {
            line: 12,
            column: 12039
          }
        },
        line: 12
      },
      '29': {
        name: '(anonymous_29)',
        decl: {
          start: {
            line: 12,
            column: 12137
          },
          end: {
            line: 12,
            column: 12138
          }
        },
        loc: {
          start: {
            line: 12,
            column: 12148
          },
          end: {
            line: 12,
            column: 12345
          }
        },
        line: 12
      },
      '30': {
        name: '(anonymous_30)',
        decl: {
          start: {
            line: 12,
            column: 12349
          },
          end: {
            line: 12,
            column: 12350
          }
        },
        loc: {
          start: {
            line: 12,
            column: 12360
          },
          end: {
            line: 12,
            column: 12602
          }
        },
        line: 12
      },
      '31': {
        name: '(anonymous_31)',
        decl: {
          start: {
            line: 12,
            column: 12606
          },
          end: {
            line: 12,
            column: 12607
          }
        },
        loc: {
          start: {
            line: 12,
            column: 12623
          },
          end: {
            line: 12,
            column: 12676
          }
        },
        line: 12
      },
      '32': {
        name: 'be',
        decl: {
          start: {
            line: 12,
            column: 12686
          },
          end: {
            line: 12,
            column: 12688
          }
        },
        loc: {
          start: {
            line: 12,
            column: 12690
          },
          end: {
            line: 12,
            column: 12894
          }
        },
        line: 12
      },
      '33': {
        name: '(anonymous_33)',
        decl: {
          start: {
            line: 12,
            column: 12721
          },
          end: {
            line: 12,
            column: 12722
          }
        },
        loc: {
          start: {
            line: 12,
            column: 12732
          },
          end: {
            line: 12,
            column: 12785
          }
        },
        line: 12
      },
      '34': {
        name: '(anonymous_34)',
        decl: {
          start: {
            line: 12,
            column: 12792
          },
          end: {
            line: 12,
            column: 12793
          }
        },
        loc: {
          start: {
            line: 12,
            column: 12802
          },
          end: {
            line: 12,
            column: 12892
          }
        },
        line: 12
      },
      '35': {
        name: 'he',
        decl: {
          start: {
            line: 12,
            column: 12903
          },
          end: {
            line: 12,
            column: 12905
          }
        },
        loc: {
          start: {
            line: 12,
            column: 12907
          },
          end: {
            line: 12,
            column: 12971
          }
        },
        line: 12
      },
      '36': {
        name: 'ke',
        decl: {
          start: {
            line: 12,
            column: 12980
          },
          end: {
            line: 12,
            column: 12982
          }
        },
        loc: {
          start: {
            line: 12,
            column: 12985
          },
          end: {
            line: 12,
            column: 13783
          }
        },
        line: 12
      },
      '37': {
        name: '(anonymous_37)',
        decl: {
          start: {
            line: 12,
            column: 12994
          },
          end: {
            line: 12,
            column: 12995
          }
        },
        loc: {
          start: {
            line: 12,
            column: 13005
          },
          end: {
            line: 12,
            column: 13283
          }
        },
        line: 12
      },
      '38': {
        name: '(anonymous_38)',
        decl: {
          start: {
            line: 12,
            column: 13322
          },
          end: {
            line: 12,
            column: 13323
          }
        },
        loc: {
          start: {
            line: 12,
            column: 13333
          },
          end: {
            line: 12,
            column: 13505
          }
        },
        line: 12
      },
      '39': {
        name: 'pe',
        decl: {
          start: {
            line: 12,
            column: 13792
          },
          end: {
            line: 12,
            column: 13794
          }
        },
        loc: {
          start: {
            line: 12,
            column: 13796
          },
          end: {
            line: 12,
            column: 13859
          }
        },
        line: 12
      },
      '40': {
        name: 'ge',
        decl: {
          start: {
            line: 12,
            column: 13868
          },
          end: {
            line: 12,
            column: 13870
          }
        },
        loc: {
          start: {
            line: 12,
            column: 13872
          },
          end: {
            line: 12,
            column: 13960
          }
        },
        line: 12
      },
      '41': {
        name: '(anonymous_41)',
        decl: {
          start: {
            line: 12,
            column: 13905
          },
          end: {
            line: 12,
            column: 13906
          }
        },
        loc: {
          start: {
            line: 12,
            column: 13915
          },
          end: {
            line: 12,
            column: 13953
          }
        },
        line: 12
      },
      '42': {
        name: '(anonymous_42)',
        decl: {
          start: {
            line: 12,
            column: 13935
          },
          end: {
            line: 12,
            column: 13936
          }
        },
        loc: {
          start: {
            line: 12,
            column: 13945
          },
          end: {
            line: 12,
            column: 13951
          }
        },
        line: 12
      },
      '43': {
        name: 'me',
        decl: {
          start: {
            line: 12,
            column: 13969
          },
          end: {
            line: 12,
            column: 13971
          }
        },
        loc: {
          start: {
            line: 12,
            column: 13973
          },
          end: {
            line: 12,
            column: 14251
          }
        },
        line: 12
      },
      '44': {
        name: '(anonymous_44)',
        decl: {
          start: {
            line: 12,
            column: 14115
          },
          end: {
            line: 12,
            column: 14116
          }
        },
        loc: {
          start: {
            line: 12,
            column: 14126
          },
          end: {
            line: 12,
            column: 14146
          }
        },
        line: 12
      },
      '45': {
        name: '(anonymous_45)',
        decl: {
          start: {
            line: 12,
            column: 14199
          },
          end: {
            line: 12,
            column: 14200
          }
        },
        loc: {
          start: {
            line: 12,
            column: 14209
          },
          end: {
            line: 12,
            column: 14219
          }
        },
        line: 12
      },
      '46': {
        name: 'fe',
        decl: {
          start: {
            line: 12,
            column: 14260
          },
          end: {
            line: 12,
            column: 14262
          }
        },
        loc: {
          start: {
            line: 12,
            column: 14264
          },
          end: {
            line: 12,
            column: 14399
          }
        },
        line: 12
      },
      '47': {
        name: '(anonymous_47)',
        decl: {
          start: {
            line: 12,
            column: 14658
          },
          end: {
            line: 12,
            column: 14659
          }
        },
        loc: {
          start: {
            line: 12,
            column: 14668
          },
          end: {
            line: 12,
            column: 14717
          }
        },
        line: 12
      }
    },
    branchMap: {
      '0': {
        loc: {
          start: {
            line: 12,
            column: 3480
          },
          end: {
            line: 12,
            column: 3520
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 12,
            column: 3480
          },
          end: {
            line: 12,
            column: 3520
          }
        }, {
          start: {
            line: 12,
            column: 3480
          },
          end: {
            line: 12,
            column: 3520
          }
        }],
        line: 12
      },
      '1': {
        loc: {
          start: {
            line: 12,
            column: 3646
          },
          end: {
            line: 12,
            column: 4339
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 12,
            column: 3646
          },
          end: {
            line: 12,
            column: 3673
          }
        }, {
          start: {
            line: 12,
            column: 3675
          },
          end: {
            line: 12,
            column: 3702
          }
        }, {
          start: {
            line: 12,
            column: 3704
          },
          end: {
            line: 12,
            column: 3729
          }
        }, {
          start: {
            line: 12,
            column: 3732
          },
          end: {
            line: 12,
            column: 4338
          }
        }],
        line: 12
      },
      '2': {
        loc: {
          start: {
            line: 12,
            column: 4340
          },
          end: {
            line: 12,
            column: 4403
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 12,
            column: 4340
          },
          end: {
            line: 12,
            column: 4390
          }
        }, {
          start: {
            line: 12,
            column: 4393
          },
          end: {
            line: 12,
            column: 4402
          }
        }],
        line: 12
      },
      '3': {
        loc: {
          start: {
            line: 12,
            column: 4343
          },
          end: {
            line: 12,
            column: 4380
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 12,
            column: 4343
          },
          end: {
            line: 12,
            column: 4344
          }
        }, {
          start: {
            line: 12,
            column: 4346
          },
          end: {
            line: 12,
            column: 4380
          }
        }],
        line: 12
      },
      '4': {
        loc: {
          start: {
            line: 12,
            column: 4446
          },
          end: {
            line: 12,
            column: 4475
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 12,
            column: 4446
          },
          end: {
            line: 12,
            column: 4454
          }
        }, {
          start: {
            line: 12,
            column: 4456
          },
          end: {
            line: 12,
            column: 4462
          }
        }, {
          start: {
            line: 12,
            column: 4465
          },
          end: {
            line: 12,
            column: 4474
          }
        }],
        line: 12
      },
      '5': {
        loc: {
          start: {
            line: 12,
            column: 4476
          },
          end: {
            line: 12,
            column: 4533
          }
        },
        type: 'cond-expr',
        locations: [{
          start: {
            line: 12,
            column: 4489
          },
          end: {
            line: 12,
            column: 4528
          }
        }, {
          start: {
            line: 12,
            column: 4530
          },
          end: {
            line: 12,
            column: 4533
          }
        }],
        line: 12
      },
      '6': {
        loc: {
          start: {
            line: 12,
            column: 4534
          },
          end: {
            line: 12,
            column: 4558
          }
        },
        type: 'cond-expr',
        locations: [{
          start: {
            line: 12,
            column: 4541
          },
          end: {
            line: 12,
            column: 4549
          }
        }, {
          start: {
            line: 12,
            column: 4550
          },
          end: {
            line: 12,
            column: 4558
          }
        }],
        line: 12
      },
      '7': {
        loc: {
          start: {
            line: 12,
            column: 4559
          },
          end: {
            line: 12,
            column: 4583
          }
        },
        type: 'cond-expr',
        locations: [{
          start: {
            line: 12,
            column: 4566
          },
          end: {
            line: 12,
            column: 4574
          }
        }, {
          start: {
            line: 12,
            column: 4575
          },
          end: {
            line: 12,
            column: 4583
          }
        }],
        line: 12
      },
      '8': {
        loc: {
          start: {
            line: 12,
            column: 4584
          },
          end: {
            line: 12,
            column: 4691
          }
        },
        type: 'cond-expr',
        locations: [{
          start: {
            line: 12,
            column: 4602
          },
          end: {
            line: 12,
            column: 4645
          }
        }, {
          start: {
            line: 12,
            column: 4648
          },
          end: {
            line: 12,
            column: 4690
          }
        }],
        line: 12
      },
      '9': {
        loc: {
          start: {
            line: 12,
            column: 4584
          },
          end: {
            line: 12,
            column: 4600
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 12,
            column: 4584
          },
          end: {
            line: 12,
            column: 4592
          }
        }, {
          start: {
            line: 12,
            column: 4594
          },
          end: {
            line: 12,
            column: 4600
          }
        }],
        line: 12
      },
      '10': {
        loc: {
          start: {
            line: 12,
            column: 4692
          },
          end: {
            line: 12,
            column: 4803
          }
        },
        type: 'cond-expr',
        locations: [{
          start: {
            line: 12,
            column: 4714
          },
          end: {
            line: 12,
            column: 4757
          }
        }, {
          start: {
            line: 12,
            column: 4760
          },
          end: {
            line: 12,
            column: 4802
          }
        }],
        line: 12
      },
      '11': {
        loc: {
          start: {
            line: 12,
            column: 4692
          },
          end: {
            line: 12,
            column: 4712
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 12,
            column: 4692
          },
          end: {
            line: 12,
            column: 4704
          }
        }, {
          start: {
            line: 12,
            column: 4706
          },
          end: {
            line: 12,
            column: 4712
          }
        }],
        line: 12
      },
      '12': {
        loc: {
          start: {
            line: 12,
            column: 4804
          },
          end: {
            line: 12,
            column: 4870
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 12,
            column: 4804
          },
          end: {
            line: 12,
            column: 4810
          }
        }, {
          start: {
            line: 12,
            column: 4812
          },
          end: {
            line: 12,
            column: 4818
          }
        }, {
          start: {
            line: 12,
            column: 4821
          },
          end: {
            line: 12,
            column: 4869
          }
        }],
        line: 12
      },
      '13': {
        loc: {
          start: {
            line: 12,
            column: 4892
          },
          end: {
            line: 12,
            column: 5673
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 12,
            column: 4892
          },
          end: {
            line: 12,
            column: 4905
          }
        }, {
          start: {
            line: 12,
            column: 4908
          },
          end: {
            line: 12,
            column: 4910
          }
        }, {
          start: {
            line: 12,
            column: 4913
          },
          end: {
            line: 12,
            column: 5671
          }
        }],
        line: 12
      },
      '14': {
        loc: {
          start: {
            line: 12,
            column: 4920
          },
          end: {
            line: 12,
            column: 4961
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 12,
            column: 4920
          },
          end: {
            line: 12,
            column: 4937
          }
        }, {
          start: {
            line: 12,
            column: 4939
          },
          end: {
            line: 12,
            column: 4961
          }
        }],
        line: 12
      },
      '15': {
        loc: {
          start: {
            line: 12,
            column: 5050
          },
          end: {
            line: 12,
            column: 5080
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 12,
            column: 5050
          },
          end: {
            line: 12,
            column: 5064
          }
        }, {
          start: {
            line: 12,
            column: 5066
          },
          end: {
            line: 12,
            column: 5080
          }
        }],
        line: 12
      },
      '16': {
        loc: {
          start: {
            line: 12,
            column: 5104
          },
          end: {
            line: 12,
            column: 5156
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 12,
            column: 5104
          },
          end: {
            line: 12,
            column: 5123
          }
        }, {
          start: {
            line: 12,
            column: 5125
          },
          end: {
            line: 12,
            column: 5152
          }
        }, {
          start: {
            line: 12,
            column: 5154
          },
          end: {
            line: 12,
            column: 5156
          }
        }],
        line: 12
      },
      '17': {
        loc: {
          start: {
            line: 12,
            column: 5157
          },
          end: {
            line: 12,
            column: 5215
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 12,
            column: 5157
          },
          end: {
            line: 12,
            column: 5162
          }
        }, {
          start: {
            line: 12,
            column: 5164
          },
          end: {
            line: 12,
            column: 5215
          }
        }],
        line: 12
      },
      '18': {
        loc: {
          start: {
            line: 12,
            column: 5216
          },
          end: {
            line: 12,
            column: 5273
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 12,
            column: 5216
          },
          end: {
            line: 12,
            column: 5221
          }
        }, {
          start: {
            line: 12,
            column: 5223
          },
          end: {
            line: 12,
            column: 5273
          }
        }],
        line: 12
      },
      '19': {
        loc: {
          start: {
            line: 12,
            column: 5471
          },
          end: {
            line: 12,
            column: 5631
          }
        },
        type: 'cond-expr',
        locations: [{
          start: {
            line: 12,
            column: 5498
          },
          end: {
            line: 12,
            column: 5502
          }
        }, {
          start: {
            line: 12,
            column: 5503
          },
          end: {
            line: 12,
            column: 5631
          }
        }],
        line: 12
      },
      '20': {
        loc: {
          start: {
            line: 12,
            column: 5503
          },
          end: {
            line: 12,
            column: 5631
          }
        },
        type: 'cond-expr',
        locations: [{
          start: {
            line: 12,
            column: 5530
          },
          end: {
            line: 12,
            column: 5534
          }
        }, {
          start: {
            line: 12,
            column: 5535
          },
          end: {
            line: 12,
            column: 5631
          }
        }],
        line: 12
      },
      '21': {
        loc: {
          start: {
            line: 12,
            column: 5535
          },
          end: {
            line: 12,
            column: 5631
          }
        },
        type: 'cond-expr',
        locations: [{
          start: {
            line: 12,
            column: 5560
          },
          end: {
            line: 12,
            column: 5564
          }
        }, {
          start: {
            line: 12,
            column: 5565
          },
          end: {
            line: 12,
            column: 5631
          }
        }],
        line: 12
      },
      '22': {
        loc: {
          start: {
            line: 12,
            column: 5565
          },
          end: {
            line: 12,
            column: 5631
          }
        },
        type: 'cond-expr',
        locations: [{
          start: {
            line: 12,
            column: 5591
          },
          end: {
            line: 12,
            column: 5596
          }
        }, {
          start: {
            line: 12,
            column: 5598
          },
          end: {
            line: 12,
            column: 5630
          }
        }],
        line: 12
      },
      '23': {
        loc: {
          start: {
            line: 12,
            column: 5689
          },
          end: {
            line: 12,
            column: 5709
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 12,
            column: 5689
          },
          end: {
            line: 12,
            column: 5703
          }
        }, {
          start: {
            line: 12,
            column: 5705
          },
          end: {
            line: 12,
            column: 5709
          }
        }],
        line: 12
      },
      '24': {
        loc: {
          start: {
            line: 12,
            column: 5710
          },
          end: {
            line: 12,
            column: 5738
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 12,
            column: 5710
          },
          end: {
            line: 12,
            column: 5723
          }
        }, {
          start: {
            line: 12,
            column: 5725
          },
          end: {
            line: 12,
            column: 5731
          }
        }, {
          start: {
            line: 12,
            column: 5733
          },
          end: {
            line: 12,
            column: 5738
          }
        }],
        line: 12
      },
      '25': {
        loc: {
          start: {
            line: 12,
            column: 5739
          },
          end: {
            line: 12,
            column: 5767
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 12,
            column: 5739
          },
          end: {
            line: 12,
            column: 5752
          }
        }, {
          start: {
            line: 12,
            column: 5754
          },
          end: {
            line: 12,
            column: 5760
          }
        }, {
          start: {
            line: 12,
            column: 5762
          },
          end: {
            line: 12,
            column: 5767
          }
        }],
        line: 12
      },
      '26': {
        loc: {
          start: {
            line: 12,
            column: 5782
          },
          end: {
            line: 12,
            column: 5824
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 12,
            column: 5782
          },
          end: {
            line: 12,
            column: 5824
          }
        }, {
          start: {
            line: 12,
            column: 5782
          },
          end: {
            line: 12,
            column: 5824
          }
        }],
        line: 12
      },
      '27': {
        loc: {
          start: {
            line: 12,
            column: 6385
          },
          end: {
            line: 12,
            column: 6449
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 12,
            column: 6385
          },
          end: {
            line: 12,
            column: 6449
          }
        }, {
          start: {
            line: 12,
            column: 6385
          },
          end: {
            line: 12,
            column: 6449
          }
        }],
        line: 12
      },
      '28': {
        loc: {
          start: {
            line: 12,
            column: 6449
          },
          end: {
            line: 12,
            column: 9518
          }
        },
        type: 'switch',
        locations: [{
          start: {
            line: 12,
            column: 6850
          },
          end: {
            line: 12,
            column: 6920
          }
        }, {
          start: {
            line: 12,
            column: 6920
          },
          end: {
            line: 12,
            column: 7080
          }
        }, {
          start: {
            line: 12,
            column: 7080
          },
          end: {
            line: 12,
            column: 7310
          }
        }, {
          start: {
            line: 12,
            column: 7310
          },
          end: {
            line: 12,
            column: 7454
          }
        }, {
          start: {
            line: 12,
            column: 7454
          },
          end: {
            line: 12,
            column: 7533
          }
        }, {
          start: {
            line: 12,
            column: 7533
          },
          end: {
            line: 12,
            column: 7671
          }
        }, {
          start: {
            line: 12,
            column: 7671
          },
          end: {
            line: 12,
            column: 7854
          }
        }, {
          start: {
            line: 12,
            column: 7854
          },
          end: {
            line: 12,
            column: 8379
          }
        }, {
          start: {
            line: 12,
            column: 8379
          },
          end: {
            line: 12,
            column: 8763
          }
        }, {
          start: {
            line: 12,
            column: 8763
          },
          end: {
            line: 12,
            column: 9314
          }
        }, {
          start: {
            line: 12,
            column: 9314
          },
          end: {
            line: 12,
            column: 9517
          }
        }],
        line: 12
      },
      '29': {
        loc: {
          start: {
            line: 12,
            column: 6523
          },
          end: {
            line: 12,
            column: 6564
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 12,
            column: 6523
          },
          end: {
            line: 12,
            column: 6540
          }
        }, {
          start: {
            line: 12,
            column: 6542
          },
          end: {
            line: 12,
            column: 6564
          }
        }],
        line: 12
      },
      '30': {
        loc: {
          start: {
            line: 12,
            column: 6614
          },
          end: {
            line: 12,
            column: 6645
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 12,
            column: 6614
          },
          end: {
            line: 12,
            column: 6632
          }
        }, {
          start: {
            line: 12,
            column: 6634
          },
          end: {
            line: 12,
            column: 6645
          }
        }],
        line: 12
      },
      '31': {
        loc: {
          start: {
            line: 12,
            column: 6702
          },
          end: {
            line: 12,
            column: 6732
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 12,
            column: 6702
          },
          end: {
            line: 12,
            column: 6716
          }
        }, {
          start: {
            line: 12,
            column: 6718
          },
          end: {
            line: 12,
            column: 6732
          }
        }],
        line: 12
      },
      '32': {
        loc: {
          start: {
            line: 12,
            column: 6735
          },
          end: {
            line: 12,
            column: 6752
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 12,
            column: 6735
          },
          end: {
            line: 12,
            column: 6748
          }
        }, {
          start: {
            line: 12,
            column: 6750
          },
          end: {
            line: 12,
            column: 6752
          }
        }],
        line: 12
      },
      '33': {
        loc: {
          start: {
            line: 12,
            column: 6755
          },
          end: {
            line: 12,
            column: 6786
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 12,
            column: 6755
          },
          end: {
            line: 12,
            column: 6782
          }
        }, {
          start: {
            line: 12,
            column: 6784
          },
          end: {
            line: 12,
            column: 6786
          }
        }],
        line: 12
      },
      '34': {
        loc: {
          start: {
            line: 12,
            column: 10423
          },
          end: {
            line: 12,
            column: 10461
          }
        },
        type: 'cond-expr',
        locations: [{
          start: {
            line: 12,
            column: 10447
          },
          end: {
            line: 12,
            column: 10455
          }
        }, {
          start: {
            line: 12,
            column: 10456
          },
          end: {
            line: 12,
            column: 10461
          }
        }],
        line: 12
      },
      '35': {
        loc: {
          start: {
            line: 12,
            column: 11066
          },
          end: {
            line: 12,
            column: 11226
          }
        },
        type: 'cond-expr',
        locations: [{
          start: {
            line: 12,
            column: 11093
          },
          end: {
            line: 12,
            column: 11097
          }
        }, {
          start: {
            line: 12,
            column: 11098
          },
          end: {
            line: 12,
            column: 11226
          }
        }],
        line: 12
      },
      '36': {
        loc: {
          start: {
            line: 12,
            column: 11098
          },
          end: {
            line: 12,
            column: 11226
          }
        },
        type: 'cond-expr',
        locations: [{
          start: {
            line: 12,
            column: 11125
          },
          end: {
            line: 12,
            column: 11129
          }
        }, {
          start: {
            line: 12,
            column: 11130
          },
          end: {
            line: 12,
            column: 11226
          }
        }],
        line: 12
      },
      '37': {
        loc: {
          start: {
            line: 12,
            column: 11130
          },
          end: {
            line: 12,
            column: 11226
          }
        },
        type: 'cond-expr',
        locations: [{
          start: {
            line: 12,
            column: 11155
          },
          end: {
            line: 12,
            column: 11159
          }
        }, {
          start: {
            line: 12,
            column: 11160
          },
          end: {
            line: 12,
            column: 11226
          }
        }],
        line: 12
      },
      '38': {
        loc: {
          start: {
            line: 12,
            column: 11160
          },
          end: {
            line: 12,
            column: 11226
          }
        },
        type: 'cond-expr',
        locations: [{
          start: {
            line: 12,
            column: 11186
          },
          end: {
            line: 12,
            column: 11191
          }
        }, {
          start: {
            line: 12,
            column: 11193
          },
          end: {
            line: 12,
            column: 11225
          }
        }],
        line: 12
      },
      '39': {
        loc: {
          start: {
            line: 12,
            column: 11483
          },
          end: {
            line: 12,
            column: 11611
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 12,
            column: 11483
          },
          end: {
            line: 12,
            column: 11611
          }
        }, {
          start: {
            line: 12,
            column: 11483
          },
          end: {
            line: 12,
            column: 11611
          }
        }],
        line: 12
      },
      '40': {
        loc: {
          start: {
            line: 12,
            column: 11544
          },
          end: {
            line: 12,
            column: 11610
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 12,
            column: 11544
          },
          end: {
            line: 12,
            column: 11557
          }
        }, {
          start: {
            line: 12,
            column: 11559
          },
          end: {
            line: 12,
            column: 11565
          }
        }, {
          start: {
            line: 12,
            column: 11568
          },
          end: {
            line: 12,
            column: 11609
          }
        }],
        line: 12
      },
      '41': {
        loc: {
          start: {
            line: 12,
            column: 11627
          },
          end: {
            line: 12,
            column: 11781
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 12,
            column: 11627
          },
          end: {
            line: 12,
            column: 11781
          }
        }, {
          start: {
            line: 12,
            column: 11627
          },
          end: {
            line: 12,
            column: 11781
          }
        }],
        line: 12
      },
      '42': {
        loc: {
          start: {
            line: 12,
            column: 11656
          },
          end: {
            line: 12,
            column: 11685
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 12,
            column: 11656
          },
          end: {
            line: 12,
            column: 11665
          }
        }, {
          start: {
            line: 12,
            column: 11667
          },
          end: {
            line: 12,
            column: 11673
          }
        }, {
          start: {
            line: 12,
            column: 11676
          },
          end: {
            line: 12,
            column: 11684
          }
        }],
        line: 12
      },
      '43': {
        loc: {
          start: {
            line: 12,
            column: 11686
          },
          end: {
            line: 12,
            column: 11709
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 12,
            column: 11686
          },
          end: {
            line: 12,
            column: 11689
          }
        }, {
          start: {
            line: 12,
            column: 11691
          },
          end: {
            line: 12,
            column: 11697
          }
        }, {
          start: {
            line: 12,
            column: 11700
          },
          end: {
            line: 12,
            column: 11708
          }
        }],
        line: 12
      },
      '44': {
        loc: {
          start: {
            line: 12,
            column: 11710
          },
          end: {
            line: 12,
            column: 11780
          }
        },
        type: 'cond-expr',
        locations: [{
          start: {
            line: 12,
            column: 11733
          },
          end: {
            line: 12,
            column: 11738
          }
        }, {
          start: {
            line: 12,
            column: 11739
          },
          end: {
            line: 12,
            column: 11780
          }
        }],
        line: 12
      },
      '45': {
        loc: {
          start: {
            line: 12,
            column: 11710
          },
          end: {
            line: 12,
            column: 11732
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 12,
            column: 11710
          },
          end: {
            line: 12,
            column: 11724
          }
        }, {
          start: {
            line: 12,
            column: 11726
          },
          end: {
            line: 12,
            column: 11732
          }
        }],
        line: 12
      },
      '46': {
        loc: {
          start: {
            line: 12,
            column: 11782
          },
          end: {
            line: 12,
            column: 11817
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 12,
            column: 11782
          },
          end: {
            line: 12,
            column: 11797
          }
        }, {
          start: {
            line: 12,
            column: 11800
          },
          end: {
            line: 12,
            column: 11816
          }
        }],
        line: 12
      },
      '47': {
        loc: {
          start: {
            line: 12,
            column: 11865
          },
          end: {
            line: 12,
            column: 12038
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 12,
            column: 11866
          },
          end: {
            line: 12,
            column: 11897
          }
        }, {
          start: {
            line: 12,
            column: 11899
          },
          end: {
            line: 12,
            column: 11930
          }
        }, {
          start: {
            line: 12,
            column: 11932
          },
          end: {
            line: 12,
            column: 11961
          }
        }, {
          start: {
            line: 12,
            column: 11963
          },
          end: {
            line: 12,
            column: 11996
          }
        }, {
          start: {
            line: 12,
            column: 11998
          },
          end: {
            line: 12,
            column: 12031
          }
        }, {
          start: {
            line: 12,
            column: 12034
          },
          end: {
            line: 12,
            column: 12038
          }
        }],
        line: 12
      },
      '48': {
        loc: {
          start: {
            line: 12,
            column: 12155
          },
          end: {
            line: 12,
            column: 12292
          }
        },
        type: 'switch',
        locations: [{
          start: {
            line: 12,
            column: 12170
          },
          end: {
            line: 12,
            column: 12202
          }
        }, {
          start: {
            line: 12,
            column: 12202
          },
          end: {
            line: 12,
            column: 12216
          }
        }, {
          start: {
            line: 12,
            column: 12216
          },
          end: {
            line: 12,
            column: 12245
          }
        }, {
          start: {
            line: 12,
            column: 12245
          },
          end: {
            line: 12,
            column: 12277
          }
        }, {
          start: {
            line: 12,
            column: 12277
          },
          end: {
            line: 12,
            column: 12291
          }
        }],
        line: 12
      },
      '49': {
        loc: {
          start: {
            line: 12,
            column: 12367
          },
          end: {
            line: 12,
            column: 12491
          }
        },
        type: 'switch',
        locations: [{
          start: {
            line: 12,
            column: 12382
          },
          end: {
            line: 12,
            column: 12415
          }
        }, {
          start: {
            line: 12,
            column: 12415
          },
          end: {
            line: 12,
            column: 12444
          }
        }, {
          start: {
            line: 12,
            column: 12444
          },
          end: {
            line: 12,
            column: 12476
          }
        }, {
          start: {
            line: 12,
            column: 12476
          },
          end: {
            line: 12,
            column: 12490
          }
        }],
        line: 12
      },
      '50': {
        loc: {
          start: {
            line: 12,
            column: 12528
          },
          end: {
            line: 12,
            column: 12578
          }
        },
        type: 'cond-expr',
        locations: [{
          start: {
            line: 12,
            column: 12537
          },
          end: {
            line: 12,
            column: 12554
          }
        }, {
          start: {
            line: 12,
            column: 12555
          },
          end: {
            line: 12,
            column: 12578
          }
        }],
        line: 12
      },
      '51': {
        loc: {
          start: {
            line: 12,
            column: 13170
          },
          end: {
            line: 12,
            column: 13254
          }
        },
        type: 'cond-expr',
        locations: [{
          start: {
            line: 12,
            column: 13200
          },
          end: {
            line: 12,
            column: 13211
          }
        }, {
          start: {
            line: 12,
            column: 13212
          },
          end: {
            line: 12,
            column: 13254
          }
        }],
        line: 12
      },
      '52': {
        loc: {
          start: {
            line: 12,
            column: 13212
          },
          end: {
            line: 12,
            column: 13254
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 12,
            column: 13212
          },
          end: {
            line: 12,
            column: 13241
          }
        }, {
          start: {
            line: 12,
            column: 13244
          },
          end: {
            line: 12,
            column: 13253
          }
        }],
        line: 12
      },
      '53': {
        loc: {
          start: {
            line: 12,
            column: 13290
          },
          end: {
            line: 12,
            column: 13320
          }
        },
        type: 'cond-expr',
        locations: [{
          start: {
            line: 12,
            column: 13292
          },
          end: {
            line: 12,
            column: 13311
          }
        }, {
          start: {
            line: 12,
            column: 13312
          },
          end: {
            line: 12,
            column: 13320
          }
        }],
        line: 12
      },
      '54': {
        loc: {
          start: {
            line: 12,
            column: 13378
          },
          end: {
            line: 12,
            column: 13485
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 12,
            column: 13378
          },
          end: {
            line: 12,
            column: 13485
          }
        }, {
          start: {
            line: 12,
            column: 13378
          },
          end: {
            line: 12,
            column: 13485
          }
        }],
        line: 12
      },
      '55': {
        loc: {
          start: {
            line: 12,
            column: 13509
          },
          end: {
            line: 12,
            column: 13616
          }
        },
        type: 'cond-expr',
        locations: [{
          start: {
            line: 12,
            column: 13525
          },
          end: {
            line: 12,
            column: 13560
          }
        }, {
          start: {
            line: 12,
            column: 13561
          },
          end: {
            line: 12,
            column: 13616
          }
        }],
        line: 12
      },
      '56': {
        loc: {
          start: {
            line: 12,
            column: 13561
          },
          end: {
            line: 12,
            column: 13616
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 12,
            column: 13561
          },
          end: {
            line: 12,
            column: 13578
          }
        }, {
          start: {
            line: 12,
            column: 13581
          },
          end: {
            line: 12,
            column: 13615
          }
        }],
        line: 12
      },
      '57': {
        loc: {
          start: {
            line: 12,
            column: 13873
          },
          end: {
            line: 12,
            column: 13959
          }
        },
        type: 'cond-expr',
        locations: [{
          start: {
            line: 12,
            column: 13898
          },
          end: {
            line: 12,
            column: 13954
          }
        }, {
          start: {
            line: 12,
            column: 13955
          },
          end: {
            line: 12,
            column: 13959
          }
        }],
        line: 12
      },
      '58': {
        loc: {
          start: {
            line: 12,
            column: 14310
          },
          end: {
            line: 12,
            column: 14331
          }
        },
        type: 'cond-expr',
        locations: [{
          start: {
            line: 12,
            column: 14317
          },
          end: {
            line: 12,
            column: 14324
          }
        }, {
          start: {
            line: 12,
            column: 14325
          },
          end: {
            line: 12,
            column: 14331
          }
        }],
        line: 12
      },
      '59': {
        loc: {
          start: {
            line: 12,
            column: 14399
          },
          end: {
            line: 12,
            column: 14640
          }
        },
        type: 'cond-expr',
        locations: [{
          start: {
            line: 12,
            column: 14424
          },
          end: {
            line: 12,
            column: 14516
          }
        }, {
          start: {
            line: 12,
            column: 14519
          },
          end: {
            line: 12,
            column: 14639
          }
        }],
        line: 12
      },
      '60': {
        loc: {
          start: {
            line: 12,
            column: 14669
          },
          end: {
            line: 12,
            column: 14716
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 12,
            column: 14669
          },
          end: {
            line: 12,
            column: 14694
          }
        }, {
          start: {
            line: 12,
            column: 14696
          },
          end: {
            line: 12,
            column: 14716
          }
        }],
        line: 12
      }
    },
    s: {
      '0': 0,
      '1': 0,
      '2': 0,
      '3': 0,
      '4': 0,
      '5': 0,
      '6': 0,
      '7': 0,
      '8': 0,
      '9': 0,
      '10': 0,
      '11': 0,
      '12': 0,
      '13': 0,
      '14': 0,
      '15': 0,
      '16': 0,
      '17': 0,
      '18': 0,
      '19': 0,
      '20': 0,
      '21': 0,
      '22': 0,
      '23': 0,
      '24': 0,
      '25': 0,
      '26': 0,
      '27': 0,
      '28': 0,
      '29': 0,
      '30': 0,
      '31': 0,
      '32': 0,
      '33': 0,
      '34': 0,
      '35': 0,
      '36': 0,
      '37': 0,
      '38': 0,
      '39': 0,
      '40': 0,
      '41': 0,
      '42': 0,
      '43': 0,
      '44': 0,
      '45': 0,
      '46': 0,
      '47': 0,
      '48': 0,
      '49': 0,
      '50': 0,
      '51': 0,
      '52': 0,
      '53': 0,
      '54': 0,
      '55': 0,
      '56': 0,
      '57': 0,
      '58': 0,
      '59': 0,
      '60': 0,
      '61': 0,
      '62': 0,
      '63': 0,
      '64': 0,
      '65': 0,
      '66': 0,
      '67': 0,
      '68': 0,
      '69': 0,
      '70': 0,
      '71': 0,
      '72': 0,
      '73': 0,
      '74': 0,
      '75': 0,
      '76': 0,
      '77': 0,
      '78': 0,
      '79': 0,
      '80': 0,
      '81': 0,
      '82': 0,
      '83': 0,
      '84': 0,
      '85': 0,
      '86': 0,
      '87': 0,
      '88': 0,
      '89': 0,
      '90': 0,
      '91': 0,
      '92': 0,
      '93': 0,
      '94': 0,
      '95': 0,
      '96': 0,
      '97': 0,
      '98': 0,
      '99': 0,
      '100': 0,
      '101': 0,
      '102': 0,
      '103': 0,
      '104': 0,
      '105': 0,
      '106': 0,
      '107': 0,
      '108': 0,
      '109': 0,
      '110': 0,
      '111': 0,
      '112': 0,
      '113': 0,
      '114': 0,
      '115': 0,
      '116': 0,
      '117': 0,
      '118': 0,
      '119': 0,
      '120': 0
    },
    f: {
      '0': 0,
      '1': 0,
      '2': 0,
      '3': 0,
      '4': 0,
      '5': 0,
      '6': 0,
      '7': 0,
      '8': 0,
      '9': 0,
      '10': 0,
      '11': 0,
      '12': 0,
      '13': 0,
      '14': 0,
      '15': 0,
      '16': 0,
      '17': 0,
      '18': 0,
      '19': 0,
      '20': 0,
      '21': 0,
      '22': 0,
      '23': 0,
      '24': 0,
      '25': 0,
      '26': 0,
      '27': 0,
      '28': 0,
      '29': 0,
      '30': 0,
      '31': 0,
      '32': 0,
      '33': 0,
      '34': 0,
      '35': 0,
      '36': 0,
      '37': 0,
      '38': 0,
      '39': 0,
      '40': 0,
      '41': 0,
      '42': 0,
      '43': 0,
      '44': 0,
      '45': 0,
      '46': 0,
      '47': 0
    },
    b: {
      '0': [0, 0],
      '1': [0, 0, 0, 0],
      '2': [0, 0],
      '3': [0, 0],
      '4': [0, 0, 0],
      '5': [0, 0],
      '6': [0, 0],
      '7': [0, 0],
      '8': [0, 0],
      '9': [0, 0],
      '10': [0, 0],
      '11': [0, 0],
      '12': [0, 0, 0],
      '13': [0, 0, 0],
      '14': [0, 0],
      '15': [0, 0],
      '16': [0, 0, 0],
      '17': [0, 0],
      '18': [0, 0],
      '19': [0, 0],
      '20': [0, 0],
      '21': [0, 0],
      '22': [0, 0],
      '23': [0, 0],
      '24': [0, 0, 0],
      '25': [0, 0, 0],
      '26': [0, 0],
      '27': [0, 0],
      '28': [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
      '29': [0, 0],
      '30': [0, 0],
      '31': [0, 0],
      '32': [0, 0],
      '33': [0, 0],
      '34': [0, 0],
      '35': [0, 0],
      '36': [0, 0],
      '37': [0, 0],
      '38': [0, 0],
      '39': [0, 0],
      '40': [0, 0, 0],
      '41': [0, 0],
      '42': [0, 0, 0],
      '43': [0, 0, 0],
      '44': [0, 0],
      '45': [0, 0],
      '46': [0, 0],
      '47': [0, 0, 0, 0, 0, 0],
      '48': [0, 0, 0, 0, 0],
      '49': [0, 0, 0, 0],
      '50': [0, 0],
      '51': [0, 0],
      '52': [0, 0],
      '53': [0, 0],
      '54': [0, 0],
      '55': [0, 0],
      '56': [0, 0],
      '57': [0, 0],
      '58': [0, 0],
      '59': [0, 0],
      '60': [0, 0]
    },
    _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

cov_1hsdzkih27.s[0]++;

!function (e) {
  "use strict";
  cov_1hsdzkih27.f[0]++;
  var s,
      i,
      a,
      t,
      o,
      c,
      r,
      l,
      d,
      n,
      v,
      u,
      b,
      h,
      k,
      p,
      g,
      m,
      f,
      x,
      w,
      y,
      _,
      C,
      z,
      B,
      P,
      M,
      E,
      O,
      D,
      N,
      U,
      V,
      I,
      j,
      R,
      X,
      Y,
      W,
      q,
      $,
      T,
      A,
      H,
      Q,
      S,
      Z = (cov_1hsdzkih27.s[1]++, '<svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24"><path d="M12 0c-6.627 0-12 5.372-12 12 0 5.084 3.163 9.426 7.627 11.174-.105-.949-.2-2.405.042-3.441.218-.937 1.407-5.965 1.407-5.965s-.359-.719-.359-1.782c0-1.668.967-2.914 2.171-2.914 1.023 0 1.518.769 1.518 1.69 0 1.029-.655 2.568-.994 3.995-.283 1.194.599 2.169 1.777 2.169 2.133 0 3.772-2.249 3.772-5.495 0-2.873-2.064-4.882-5.012-4.882-3.414 0-5.418 2.561-5.418 5.207 0 1.031.397 2.138.893 2.738.098.119.112.224.083.345l-.333 1.36c-.053.22-.174.267-.402.161-1.499-.698-2.436-2.889-2.436-4.649 0-3.785 2.75-7.262 7.929-7.262 4.163 0 7.398 2.967 7.398 6.931 0 4.136-2.607 7.464-6.227 7.464-1.216 0-2.359-.631-2.75-1.378l-.748 2.853c-.271 1.043-1.002 2.35-1.492 3.146 1.124.347 2.317.535 3.554.535 6.627 0 12-5.373 12-12 0-6.628-5.373-12-12-12z" fill-rule="evenodd" clip-rule="evenodd"/></svg>'),
      F = (cov_1hsdzkih27.s[2]++, '<svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24"><path d="M12 0c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zm3 8h-1.35c-.538 0-.65.221-.65.778v1.222h2l-.209 2h-1.791v7h-3v-7h-2v-2h2v-2.308c0-1.769.931-2.692 3.029-2.692h1.971v3z"/></svg>'),
      G = (cov_1hsdzkih27.s[3]++, '<svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24"><path d="M12 0c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zm6.066 9.645c.183 4.04-2.83 8.544-8.164 8.544-1.622 0-3.131-.476-4.402-1.291 1.524.18 3.045-.244 4.252-1.189-1.256-.023-2.317-.854-2.684-1.995.451.086.895.061 1.298-.049-1.381-.278-2.335-1.522-2.304-2.853.388.215.83.344 1.301.359-1.279-.855-1.641-2.544-.889-3.835 1.416 1.738 3.533 2.881 5.92 3.001-.419-1.796.944-3.527 2.799-3.527.825 0 1.572.349 2.096.907.654-.128 1.27-.368 1.824-.697-.215.671-.67 1.233-1.263 1.589.581-.07 1.135-.224 1.649-.453-.384.578-.87 1.084-1.433 1.489z"/></svg>'),
      J = (cov_1hsdzkih27.s[4]++, '<svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24"><path d="M12 0c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zm-2 16h-2v-6h2v6zm-1-6.891c-.607 0-1.1-.496-1.1-1.109 0-.612.492-1.109 1.1-1.109s1.1.497 1.1 1.109c0 .613-.493 1.109-1.1 1.109zm8 6.891h-1.998v-2.861c0-1.881-2.002-1.722-2.002 0v2.861h-2v-6h2v1.093c.872-1.616 4-1.736 4 1.548v3.359z"/></svg>'),
      K = (cov_1hsdzkih27.s[5]++, '<svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24"><path d="M12 0c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zm2 9h-4v-1h4v1zm0-3v1h-4v-1h4zm-2 13l-6-6h4v-3h4v3h4l-6 6z"/></svg>');cov_1hsdzkih27.s[6]++;
  e.fn.extend({ venobox: function venobox(L) {
      cov_1hsdzkih27.f[1]++;
      var ee = (cov_1hsdzkih27.s[7]++, this),
          se = (cov_1hsdzkih27.s[8]++, e.extend({ arrowsColor: "#B6B6B6", autoplay: !1, bgcolor: "#fff", border: "0", closeBackground: "transparent", closeColor: "#d2d2d2", framewidth: "", frameheight: "", gallItems: !1, infinigall: !1, htmlClose: "&times;", htmlNext: "<span>Next</span>", htmlPrev: "<span>Prev</span>", numeratio: !1, numerationBackground: "#161617", numerationColor: "#d2d2d2", numerationPosition: "top", overlayClose: !0, overlayColor: "rgba(23,23,23,0.85)", spinner: "double-bounce", spinColor: "#d2d2d2", titleattr: "title", titleBackground: "#161617", titleColor: "#d2d2d2", titlePosition: "top", share: [], cb_pre_open: function cb_pre_open() {
          cov_1hsdzkih27.f[2]++;
          cov_1hsdzkih27.s[9]++;
          return !0;
        }, cb_post_open: function cb_post_open() {
          cov_1hsdzkih27.f[3]++;
        }, cb_pre_close: function cb_pre_close() {
          cov_1hsdzkih27.f[4]++;
          cov_1hsdzkih27.s[10]++;
          return !0;
        }, cb_post_close: function cb_post_close() {
          cov_1hsdzkih27.f[5]++;
        }, cb_post_resize: function cb_post_resize() {
          cov_1hsdzkih27.f[6]++;
        }, cb_after_nav: function cb_after_nav() {
          cov_1hsdzkih27.f[7]++;
        }, cb_content_loaded: function cb_content_loaded() {
          cov_1hsdzkih27.f[8]++;
        }, cb_init: function cb_init() {
          cov_1hsdzkih27.f[9]++;
        } }, L));cov_1hsdzkih27.s[11]++;
      return se.cb_init(ee), this.each(function () {
        cov_1hsdzkih27.f[10]++;
        cov_1hsdzkih27.s[12]++;
        if ((N = e(this)).data("venobox")) {
            cov_1hsdzkih27.b[0][0]++;
            cov_1hsdzkih27.s[13]++;
            return !0;
          } else {
          cov_1hsdzkih27.b[0][1]++;
        }function L() {
          cov_1hsdzkih27.f[11]++;
          cov_1hsdzkih27.s[14]++;
          C = N.data("gall"), x = N.data("numeratio"), k = N.data("gallItems"), p = N.data("infinigall"), H = N.data("share"), o.html(""), (cov_1hsdzkih27.b[1][0]++, "iframe" !== N.data("vbtype")) && (cov_1hsdzkih27.b[1][1]++, "inline" !== N.data("vbtype")) && (cov_1hsdzkih27.b[1][2]++, "ajax" !== N.data("vbtype")) && (cov_1hsdzkih27.b[1][3]++, (Q = { pinterest: '<a target="_blank" href="https://pinterest.com/pin/create/button/?url=' + N.prop("href") + "&media=" + N.prop("href") + "&description=" + _ + '">' + Z + "</a>", facebook: '<a target="_blank" href="https://www.facebook.com/sharer/sharer.php?u=' + N.prop("href") + '">' + F + "</a>", twitter: '<a target="_blank" href="https://twitter.com/intent/tweet?text=' + _ + "&url=" + N.prop("href") + '">' + G + "</a>", linkedin: '<a target="_blank" href="https://www.linkedin.com/sharing/share-offsite/?url=' + N.prop("href") + '">' + J + "</a>", download: '<a target="_blank" href="' + N.prop("href") + '">' + K + "</a>" }, e.each(H, function (e, s) {
            cov_1hsdzkih27.f[12]++;
            cov_1hsdzkih27.s[15]++;
            o.append(Q[s]);
          }))), (cov_1hsdzkih27.b[2][0]++, (g = (cov_1hsdzkih27.b[3][0]++, k) || (cov_1hsdzkih27.b[3][1]++, e('.vbox-item[data-gall="' + C + '"]'))).length < 2) && (cov_1hsdzkih27.b[2][1]++, (p = !1, x = !1)), z = g.eq(g.index(N) + 1), B = g.eq(g.index(N) - 1), (cov_1hsdzkih27.b[4][0]++, z.length) || (cov_1hsdzkih27.b[4][1]++, !0 !== p) || (cov_1hsdzkih27.b[4][2]++, z = g.eq(0)), g.length >= 1 ? (cov_1hsdzkih27.b[5][0]++, (U = g.index(N) + 1, t.html(U + " / " + g.length))) : (cov_1hsdzkih27.b[5][1]++, U = 1), !0 === x ? (cov_1hsdzkih27.b[6][0]++, t.show()) : (cov_1hsdzkih27.b[6][1]++, t.hide()), "" !== _ ? (cov_1hsdzkih27.b[7][0]++, c.show()) : (cov_1hsdzkih27.b[7][1]++, c.hide()), (cov_1hsdzkih27.b[9][0]++, z.length) || (cov_1hsdzkih27.b[9][1]++, !0 === p) ? (cov_1hsdzkih27.b[8][0]++, (e(".vbox-next").css("display", "block"), P = !0)) : (cov_1hsdzkih27.b[8][1]++, (e(".vbox-next").css("display", "none"), P = !1)), (cov_1hsdzkih27.b[11][0]++, g.index(N) > 0) || (cov_1hsdzkih27.b[11][1]++, !0 === p) ? (cov_1hsdzkih27.b[10][0]++, (e(".vbox-prev").css("display", "block"), M = !0)) : (cov_1hsdzkih27.b[10][1]++, (e(".vbox-prev").css("display", "none"), M = !1)), (cov_1hsdzkih27.b[12][0]++, !0 !== M) && (cov_1hsdzkih27.b[12][1]++, !0 !== P) || (cov_1hsdzkih27.b[12][2]++, (n.on(de.DOWN, ce), n.on(de.MOVE, re), n.on(de.UP, le)));
        }function ie(e) {
          cov_1hsdzkih27.f[13]++;
          cov_1hsdzkih27.s[16]++;
          return (cov_1hsdzkih27.b[13][0]++, !(e.length < 1)) && (cov_1hsdzkih27.b[13][1]++, !m) && (cov_1hsdzkih27.b[13][2]++, (m = !0, w = (cov_1hsdzkih27.b[14][0]++, e.data("overlay")) || (cov_1hsdzkih27.b[14][1]++, e.data("overlaycolor")), b = e.data("framewidth"), h = e.data("frameheight"), r = e.data("border"), i = e.data("bgcolor"), v = (cov_1hsdzkih27.b[15][0]++, e.data("href")) || (cov_1hsdzkih27.b[15][1]++, e.attr("href")), s = e.data("autoplay"), _ = (cov_1hsdzkih27.b[16][0]++, e.data("titleattr")) && (cov_1hsdzkih27.b[16][1]++, e.attr(e.data("titleattr"))) || (cov_1hsdzkih27.b[16][2]++, ""), (cov_1hsdzkih27.b[17][0]++, e === B) && (cov_1hsdzkih27.b[17][1]++, n.addClass("vbox-animated").addClass("swipe-right")), (cov_1hsdzkih27.b[18][0]++, e === z) && (cov_1hsdzkih27.b[18][1]++, n.addClass("vbox-animated").addClass("swipe-left")), O.show(), void n.animate({ opacity: 0 }, 500, function () {
            cov_1hsdzkih27.f[14]++;
            cov_1hsdzkih27.s[17]++;
            y.css("background", w), n.removeClass("vbox-animated").removeClass("swipe-left").removeClass("swipe-right").css({ "margin-left": 0, "margin-right": 0 }), "iframe" == e.data("vbtype") ? (cov_1hsdzkih27.b[19][0]++, he()) : (cov_1hsdzkih27.b[19][1]++, "inline" == e.data("vbtype") ? (cov_1hsdzkih27.b[20][0]++, pe()) : (cov_1hsdzkih27.b[20][1]++, "ajax" == e.data("vbtype") ? (cov_1hsdzkih27.b[21][0]++, be()) : (cov_1hsdzkih27.b[21][1]++, "video" == e.data("vbtype") ? (cov_1hsdzkih27.b[22][0]++, ke(s)) : (cov_1hsdzkih27.b[22][1]++, (n.html('<img src="' + v + '">'), ge()))))), N = e, L(), m = !1, se.cb_after_nav(N, U, z, B);
          })));
        }function ae(e) {
          cov_1hsdzkih27.f[15]++;
          cov_1hsdzkih27.s[18]++;
          (cov_1hsdzkih27.b[23][0]++, 27 === e.keyCode) && (cov_1hsdzkih27.b[23][1]++, te()), (cov_1hsdzkih27.b[24][0]++, 37 == e.keyCode) && (cov_1hsdzkih27.b[24][1]++, !0 === M) && (cov_1hsdzkih27.b[24][2]++, ie(B)), (cov_1hsdzkih27.b[25][0]++, 39 == e.keyCode) && (cov_1hsdzkih27.b[25][1]++, !0 === P) && (cov_1hsdzkih27.b[25][2]++, ie(z));
        }function te() {
          cov_1hsdzkih27.f[16]++;
          cov_1hsdzkih27.s[19]++;
          if (!1 === se.cb_pre_close(N, U, z, B)) {
              cov_1hsdzkih27.b[26][0]++;
              cov_1hsdzkih27.s[20]++;
              return !1;
            } else {
            cov_1hsdzkih27.b[26][1]++;
          }cov_1hsdzkih27.s[21]++;
          e("body").off("keydown", ae).removeClass("vbox-open"), N.focus(), y.animate({ opacity: 0 }, 500, function () {
            cov_1hsdzkih27.f[17]++;
            cov_1hsdzkih27.s[22]++;
            y.remove(), m = !1, se.cb_post_close();
          });
        }cov_1hsdzkih27.s[23]++;
        ee.VBclose = function () {
          cov_1hsdzkih27.f[18]++;
          cov_1hsdzkih27.s[24]++;
          te();
        }, N.addClass("vbox-item"), N.data("framewidth", se.framewidth), N.data("frameheight", se.frameheight), N.data("border", se.border), N.data("bgcolor", se.bgcolor), N.data("numeratio", se.numeratio), N.data("gallItems", se.gallItems), N.data("infinigall", se.infinigall), N.data("overlaycolor", se.overlayColor), N.data("titleattr", se.titleattr), N.data("share", se.share), N.data("venobox", !0), N.on("click", function (k) {
          cov_1hsdzkih27.f[19]++;
          cov_1hsdzkih27.s[25]++;
          if (k.preventDefault(), N = e(this), !1 === se.cb_pre_open(N)) {
              cov_1hsdzkih27.b[27][0]++;
              cov_1hsdzkih27.s[26]++;
              return !1;
            } else {
            cov_1hsdzkih27.b[27][1]++;
          }cov_1hsdzkih27.s[27]++;
          switch (N.blur(), ee.VBnext = function () {
            cov_1hsdzkih27.f[20]++;
            cov_1hsdzkih27.s[28]++;
            ie(z);
          }, ee.VBprev = function () {
            cov_1hsdzkih27.f[21]++;
            cov_1hsdzkih27.s[29]++;
            ie(B);
          }, w = (cov_1hsdzkih27.b[29][0]++, N.data("overlay")) || (cov_1hsdzkih27.b[29][1]++, N.data("overlaycolor")), b = N.data("framewidth"), h = N.data("frameheight"), s = (cov_1hsdzkih27.b[30][0]++, N.data("autoplay")) || (cov_1hsdzkih27.b[30][1]++, se.autoplay), r = N.data("border"), i = N.data("bgcolor"), P = !1, M = !1, m = !1, v = (cov_1hsdzkih27.b[31][0]++, N.data("href")) || (cov_1hsdzkih27.b[31][1]++, N.attr("href")), u = (cov_1hsdzkih27.b[32][0]++, N.data("css")) || (cov_1hsdzkih27.b[32][1]++, ""), _ = (cov_1hsdzkih27.b[33][0]++, N.attr(N.data("titleattr"))) || (cov_1hsdzkih27.b[33][1]++, ""), H = N.data("share"), E = '<div class="vbox-preloader">', se.spinner) {case "rotating-plane":
              cov_1hsdzkih27.b[28][0]++;
              cov_1hsdzkih27.s[30]++;
              E += '<div class="sk-rotating-plane"></div>';cov_1hsdzkih27.s[31]++;
              break;case "double-bounce":
              cov_1hsdzkih27.b[28][1]++;
              cov_1hsdzkih27.s[32]++;
              E += '<div class="sk-double-bounce"><div class="sk-child sk-double-bounce1"></div><div class="sk-child sk-double-bounce2"></div></div>';cov_1hsdzkih27.s[33]++;
              break;case "wave":
              cov_1hsdzkih27.b[28][2]++;
              cov_1hsdzkih27.s[34]++;
              E += '<div class="sk-wave"><div class="sk-rect sk-rect1"></div><div class="sk-rect sk-rect2"></div><div class="sk-rect sk-rect3"></div><div class="sk-rect sk-rect4"></div><div class="sk-rect sk-rect5"></div></div>';cov_1hsdzkih27.s[35]++;
              break;case "wandering-cubes":
              cov_1hsdzkih27.b[28][3]++;
              cov_1hsdzkih27.s[36]++;
              E += '<div class="sk-wandering-cubes"><div class="sk-cube sk-cube1"></div><div class="sk-cube sk-cube2"></div></div>';cov_1hsdzkih27.s[37]++;
              break;case "spinner-pulse":
              cov_1hsdzkih27.b[28][4]++;
              cov_1hsdzkih27.s[38]++;
              E += '<div class="sk-spinner sk-spinner-pulse"></div>';cov_1hsdzkih27.s[39]++;
              break;case "chasing-dots":
              cov_1hsdzkih27.b[28][5]++;
              cov_1hsdzkih27.s[40]++;
              E += '<div class="sk-chasing-dots"><div class="sk-child sk-dot1"></div><div class="sk-child sk-dot2"></div></div>';cov_1hsdzkih27.s[41]++;
              break;case "three-bounce":
              cov_1hsdzkih27.b[28][6]++;
              cov_1hsdzkih27.s[42]++;
              E += '<div class="sk-three-bounce"><div class="sk-child sk-bounce1"></div><div class="sk-child sk-bounce2"></div><div class="sk-child sk-bounce3"></div></div>';cov_1hsdzkih27.s[43]++;
              break;case "circle":
              cov_1hsdzkih27.b[28][7]++;
              cov_1hsdzkih27.s[44]++;
              E += '<div class="sk-circle"><div class="sk-circle1 sk-child"></div><div class="sk-circle2 sk-child"></div><div class="sk-circle3 sk-child"></div><div class="sk-circle4 sk-child"></div><div class="sk-circle5 sk-child"></div><div class="sk-circle6 sk-child"></div><div class="sk-circle7 sk-child"></div><div class="sk-circle8 sk-child"></div><div class="sk-circle9 sk-child"></div><div class="sk-circle10 sk-child"></div><div class="sk-circle11 sk-child"></div><div class="sk-circle12 sk-child"></div></div>';cov_1hsdzkih27.s[45]++;
              break;case "cube-grid":
              cov_1hsdzkih27.b[28][8]++;
              cov_1hsdzkih27.s[46]++;
              E += '<div class="sk-cube-grid"><div class="sk-cube sk-cube1"></div><div class="sk-cube sk-cube2"></div><div class="sk-cube sk-cube3"></div><div class="sk-cube sk-cube4"></div><div class="sk-cube sk-cube5"></div><div class="sk-cube sk-cube6"></div><div class="sk-cube sk-cube7"></div><div class="sk-cube sk-cube8"></div><div class="sk-cube sk-cube9"></div></div>';cov_1hsdzkih27.s[47]++;
              break;case "fading-circle":
              cov_1hsdzkih27.b[28][9]++;
              cov_1hsdzkih27.s[48]++;
              E += '<div class="sk-fading-circle"><div class="sk-circle1 sk-circle"></div><div class="sk-circle2 sk-circle"></div><div class="sk-circle3 sk-circle"></div><div class="sk-circle4 sk-circle"></div><div class="sk-circle5 sk-circle"></div><div class="sk-circle6 sk-circle"></div><div class="sk-circle7 sk-circle"></div><div class="sk-circle8 sk-circle"></div><div class="sk-circle9 sk-circle"></div><div class="sk-circle10 sk-circle"></div><div class="sk-circle11 sk-circle"></div><div class="sk-circle12 sk-circle"></div></div>';cov_1hsdzkih27.s[49]++;
              break;case "folding-cube":
              cov_1hsdzkih27.b[28][10]++;
              cov_1hsdzkih27.s[50]++;
              E += '<div class="sk-folding-cube"><div class="sk-cube1 sk-cube"></div><div class="sk-cube2 sk-cube"></div><div class="sk-cube4 sk-cube"></div><div class="sk-cube3 sk-cube"></div></div>';}cov_1hsdzkih27.s[51]++;
          return E += "</div>", D = '<a class="vbox-next">' + se.htmlNext + '</a><a class="vbox-prev">' + se.htmlPrev + "</a>", I = '<div class="vbox-title"></div><div class="vbox-left"><div class="vbox-num">0/0</div></div><div class="vbox-close">' + se.htmlClose + "</div>", '<div class="vbox-share"></div>', l = '<div class="vbox-overlay ' + u + '" style="background:' + w + '">' + E + '<div class="vbox-container"><div class="vbox-content"></div></div>' + I + D + '<div class="vbox-share"></div></div>', e("body").append(l).addClass("vbox-open"), e(".vbox-preloader div:not(.sk-circle) .sk-child, .vbox-preloader .sk-rotating-plane, .vbox-preloader .sk-rect, .vbox-preloader div:not(.sk-folding-cube) .sk-cube, .vbox-preloader .sk-spinner-pulse").css("background-color", se.spinColor), y = e(".vbox-overlay"), d = e(".vbox-container"), n = e(".vbox-content"), a = e(".vbox-left"), t = e(".vbox-num"), o = e(".vbox-share"), c = e(".vbox-title"), (O = e(".vbox-preloader")).show(), S = "top" == se.titlePosition ? (cov_1hsdzkih27.b[34][0]++, "bottom") : (cov_1hsdzkih27.b[34][1]++, "top"), o.css(S, "-1px"), o.css({ color: se.titleColor, fill: se.titleColor, "background-color": se.titleBackground }), c.css(se.titlePosition, "-1px"), c.css({ color: se.titleColor, "background-color": se.titleBackground }), e(".vbox-close").css({ color: se.closeColor, "background-color": se.closeBackground }), a.css(se.numerationPosition, "-1px"), a.css({ color: se.numerationColor, "background-color": se.numerationBackground }), e(".vbox-next span, .vbox-prev span").css({ "border-top-color": se.arrowsColor, "border-right-color": se.arrowsColor }), n.html(""), n.css("opacity", "0"), y.css("opacity", "0"), L(), y.animate({ opacity: 1 }, 250, function () {
            cov_1hsdzkih27.f[22]++;
            cov_1hsdzkih27.s[52]++;
            "iframe" == N.data("vbtype") ? (cov_1hsdzkih27.b[35][0]++, he()) : (cov_1hsdzkih27.b[35][1]++, "inline" == N.data("vbtype") ? (cov_1hsdzkih27.b[36][0]++, pe()) : (cov_1hsdzkih27.b[36][1]++, "ajax" == N.data("vbtype") ? (cov_1hsdzkih27.b[37][0]++, be()) : (cov_1hsdzkih27.b[37][1]++, "video" == N.data("vbtype") ? (cov_1hsdzkih27.b[38][0]++, ke(s)) : (cov_1hsdzkih27.b[38][1]++, (n.html('<img src="' + v + '">'), ge()))))), se.cb_post_open(N, U, z, B);
          }), e("body").keydown(ae), e(".vbox-prev").on("click", function () {
            cov_1hsdzkih27.f[23]++;
            cov_1hsdzkih27.s[53]++;
            ie(B);
          }), e(".vbox-next").on("click", function () {
            cov_1hsdzkih27.f[24]++;
            cov_1hsdzkih27.s[54]++;
            ie(z);
          }), !1;
        });var oe = (cov_1hsdzkih27.s[55]++, ".vbox-overlay");function ce(e) {
          cov_1hsdzkih27.f[25]++;
          cov_1hsdzkih27.s[56]++;
          n.addClass("vbox-animated"), R = Y = e.pageY, X = W = e.pageX, V = !0;
        }function re(e) {
          cov_1hsdzkih27.f[26]++;
          cov_1hsdzkih27.s[57]++;
          if (!0 === V) {
            cov_1hsdzkih27.b[39][0]++;
            cov_1hsdzkih27.s[58]++;
            W = e.pageX, Y = e.pageY, $ = W - X, T = Y - R;var s = (cov_1hsdzkih27.s[59]++, Math.abs($));cov_1hsdzkih27.s[60]++;
            (cov_1hsdzkih27.b[40][0]++, s > Math.abs(T)) && (cov_1hsdzkih27.b[40][1]++, s <= 100) && (cov_1hsdzkih27.b[40][2]++, (e.preventDefault(), n.css("margin-left", $)));
          } else {
            cov_1hsdzkih27.b[39][1]++;
          }
        }function le(e) {
          cov_1hsdzkih27.f[27]++;
          cov_1hsdzkih27.s[61]++;
          if (!0 === V) {
            cov_1hsdzkih27.b[41][0]++;
            cov_1hsdzkih27.s[62]++;
            V = !1;var s = (cov_1hsdzkih27.s[63]++, N),
                i = (cov_1hsdzkih27.s[64]++, !1);cov_1hsdzkih27.s[65]++;
            (cov_1hsdzkih27.b[42][0]++, (q = W - X) < 0) && (cov_1hsdzkih27.b[42][1]++, !0 === P) && (cov_1hsdzkih27.b[42][2]++, (s = z, i = !0)), (cov_1hsdzkih27.b[43][0]++, q > 0) && (cov_1hsdzkih27.b[43][1]++, !0 === M) && (cov_1hsdzkih27.b[43][2]++, (s = B, i = !0)), (cov_1hsdzkih27.b[45][0]++, Math.abs(q) >= A) && (cov_1hsdzkih27.b[45][1]++, !0 === i) ? (cov_1hsdzkih27.b[44][0]++, ie(s)) : (cov_1hsdzkih27.b[44][1]++, n.css({ "margin-left": 0, "margin-right": 0 }));
          } else {
            cov_1hsdzkih27.b[41][1]++;
          }
        }cov_1hsdzkih27.s[66]++;
        (cov_1hsdzkih27.b[46][0]++, se.overlayClose) || (cov_1hsdzkih27.b[46][1]++, oe = ".vbox-close"), e("body").on("click touchstart", oe, function (s) {
          cov_1hsdzkih27.f[28]++;
          cov_1hsdzkih27.s[67]++;
          ((cov_1hsdzkih27.b[47][0]++, e(s.target).is(".vbox-overlay")) || (cov_1hsdzkih27.b[47][1]++, e(s.target).is(".vbox-content")) || (cov_1hsdzkih27.b[47][2]++, e(s.target).is(".vbox-close")) || (cov_1hsdzkih27.b[47][3]++, e(s.target).is(".vbox-preloader")) || (cov_1hsdzkih27.b[47][4]++, e(s.target).is(".vbox-container"))) && (cov_1hsdzkih27.b[47][5]++, te());
        }), X = 0, W = 0, q = 0, A = 50, V = !1;cov_1hsdzkih27.s[69]++;
        cov_1hsdzkih27.s[80]++;
        cov_1hsdzkih27.s[91]++;
        var de = (cov_1hsdzkih27.s[68]++, { DOWN: "touchmousedown", UP: "touchmouseup", MOVE: "touchmousemove" }),
            ne = function ne(s) {
          cov_1hsdzkih27.f[29]++;
          var i;cov_1hsdzkih27.s[70]++;
          switch (s.type) {case "mousedown":
              cov_1hsdzkih27.b[48][0]++;
              cov_1hsdzkih27.s[71]++;
              i = de.DOWN;cov_1hsdzkih27.s[72]++;
              break;case "mouseup":
              cov_1hsdzkih27.b[48][1]++;
            case "mouseout":
              cov_1hsdzkih27.b[48][2]++;
              cov_1hsdzkih27.s[73]++;
              i = de.UP;cov_1hsdzkih27.s[74]++;
              break;case "mousemove":
              cov_1hsdzkih27.b[48][3]++;
              cov_1hsdzkih27.s[75]++;
              i = de.MOVE;cov_1hsdzkih27.s[76]++;
              break;default:
              cov_1hsdzkih27.b[48][4]++;
              cov_1hsdzkih27.s[77]++;
              return;}var a = (cov_1hsdzkih27.s[78]++, ue(i, s, s.pageX, s.pageY));cov_1hsdzkih27.s[79]++;
          e(s.target).trigger(a);
        },
            ve = function ve(s) {
          cov_1hsdzkih27.f[30]++;
          var i;cov_1hsdzkih27.s[81]++;
          switch (s.type) {case "touchstart":
              cov_1hsdzkih27.b[49][0]++;
              cov_1hsdzkih27.s[82]++;
              i = de.DOWN;cov_1hsdzkih27.s[83]++;
              break;case "touchend":
              cov_1hsdzkih27.b[49][1]++;
              cov_1hsdzkih27.s[84]++;
              i = de.UP;cov_1hsdzkih27.s[85]++;
              break;case "touchmove":
              cov_1hsdzkih27.b[49][2]++;
              cov_1hsdzkih27.s[86]++;
              i = de.MOVE;cov_1hsdzkih27.s[87]++;
              break;default:
              cov_1hsdzkih27.b[49][3]++;
              cov_1hsdzkih27.s[88]++;
              return;}var a,
              t = (cov_1hsdzkih27.s[89]++, s.originalEvent.touches[0]);cov_1hsdzkih27.s[90]++;
          a = i == de.UP ? (cov_1hsdzkih27.b[50][0]++, ue(i, s, null, null)) : (cov_1hsdzkih27.b[50][1]++, ue(i, s, t.pageX, t.pageY)), e(s.target).trigger(a);
        },
            ue = function ue(s, i, a, t) {
          cov_1hsdzkih27.f[31]++;
          cov_1hsdzkih27.s[92]++;
          return e.Event(s, { pageX: a, pageY: t, originalEvent: i });
        };function be() {
          cov_1hsdzkih27.f[32]++;
          cov_1hsdzkih27.s[93]++;
          e.ajax({ url: v, cache: !1 }).done(function (e) {
            cov_1hsdzkih27.f[33]++;
            cov_1hsdzkih27.s[94]++;
            n.html('<div class="vbox-inline">' + e + "</div>"), ge();
          }).fail(function () {
            cov_1hsdzkih27.f[34]++;
            cov_1hsdzkih27.s[95]++;
            n.html('<div class="vbox-inline"><p>Error retrieving contents, please retry</div>'), me();
          });
        }function he() {
          cov_1hsdzkih27.f[35]++;
          cov_1hsdzkih27.s[96]++;
          n.html('<iframe class="venoframe" src="' + v + '"></iframe>'), me();
        }function ke(e) {
          cov_1hsdzkih27.f[36]++;
          var s,
              i = (cov_1hsdzkih27.s[97]++, function (e) {
            cov_1hsdzkih27.f[37]++;
            var s;cov_1hsdzkih27.s[98]++;
            e.match(/(http:|https:|)\/\/(player.|www.)?(vimeo\.com|youtu(be\.com|\.be|be\.googleapis\.com))\/(video\/|embed\/|watch\?v=|v\/)?([A-Za-z0-9._%-]*)(\&\S+)?/), RegExp.$3.indexOf("youtu") > -1 ? (cov_1hsdzkih27.b[51][0]++, s = "youtube") : (cov_1hsdzkih27.b[51][1]++, (cov_1hsdzkih27.b[52][0]++, RegExp.$3.indexOf("vimeo") > -1) && (cov_1hsdzkih27.b[52][1]++, s = "vimeo"));cov_1hsdzkih27.s[99]++;
            return { type: s, id: RegExp.$6 };
          }(v)),
              a = (cov_1hsdzkih27.s[100]++, (e ? (cov_1hsdzkih27.b[53][0]++, "?rel=0&autoplay=1") : (cov_1hsdzkih27.b[53][1]++, "?rel=0")) + function (e) {
            cov_1hsdzkih27.f[38]++;
            var s = (cov_1hsdzkih27.s[101]++, ""),
                i = (cov_1hsdzkih27.s[102]++, decodeURIComponent(e).split("?"));cov_1hsdzkih27.s[103]++;
            if (void 0 !== i[1]) {
              cov_1hsdzkih27.b[54][0]++;
              var a,
                  t,
                  o = (cov_1hsdzkih27.s[104]++, i[1].split("&"));cov_1hsdzkih27.s[105]++;
              for (t = 0; t < o.length; t++) {
                cov_1hsdzkih27.s[106]++;
                a = o[t].split("="), s = s + "&" + a[0] + "=" + a[1];
              }
            } else {
              cov_1hsdzkih27.b[54][1]++;
            }cov_1hsdzkih27.s[107]++;
            return encodeURI(s);
          }(v));cov_1hsdzkih27.s[108]++;
          "vimeo" == i.type ? (cov_1hsdzkih27.b[55][0]++, s = "https://player.vimeo.com/video/") : (cov_1hsdzkih27.b[55][1]++, (cov_1hsdzkih27.b[56][0]++, "youtube" == i.type) && (cov_1hsdzkih27.b[56][1]++, s = "https://www.youtube.com/embed/")), n.html('<iframe class="venoframe vbvid" webkitallowfullscreen mozallowfullscreen allowfullscreen allow="autoplay" frameborder="0" src="' + s + i.id + a + '"></iframe>'), me();
        }function pe() {
          cov_1hsdzkih27.f[39]++;
          cov_1hsdzkih27.s[109]++;
          n.html('<div class="vbox-inline">' + e(v).html() + "</div>"), me();
        }function ge() {
          cov_1hsdzkih27.f[40]++;
          cov_1hsdzkih27.s[110]++;
          (j = n.find("img")).length ? (cov_1hsdzkih27.b[57][0]++, j.each(function () {
            cov_1hsdzkih27.f[41]++;
            cov_1hsdzkih27.s[111]++;
            e(this).one("load", function () {
              cov_1hsdzkih27.f[42]++;
              cov_1hsdzkih27.s[112]++;
              me();
            });
          })) : (cov_1hsdzkih27.b[57][1]++, me());
        }function me() {
          cov_1hsdzkih27.f[43]++;
          cov_1hsdzkih27.s[113]++;
          c.html(_), n.find(">:first-child").addClass("vbox-figlio").css({ width: b, height: h, padding: r, background: i }), e("img.vbox-figlio").on("dragstart", function (e) {
            cov_1hsdzkih27.f[44]++;
            cov_1hsdzkih27.s[114]++;
            e.preventDefault();
          }), d.scrollTop(0), fe(), n.animate({ opacity: "1" }, "slow", function () {
            cov_1hsdzkih27.f[45]++;
            cov_1hsdzkih27.s[115]++;
            O.hide();
          }), se.cb_content_loaded(N, U, z, B);
        }function fe() {
          cov_1hsdzkih27.f[46]++;
          var s = (cov_1hsdzkih27.s[116]++, n.outerHeight()),
              i = (cov_1hsdzkih27.s[117]++, e(window).height());cov_1hsdzkih27.s[118]++;
          f = s + 60 < i ? (cov_1hsdzkih27.b[58][0]++, (i - s) / 2) : (cov_1hsdzkih27.b[58][1]++, "30px"), n.css("margin-top", f), n.css("margin-bottom", f), se.cb_post_resize();
        }cov_1hsdzkih27.s[119]++;
        "ontouchstart" in window ? (cov_1hsdzkih27.b[59][0]++, (e(document).on("touchstart", ve), e(document).on("touchmove", ve), e(document).on("touchend", ve))) : (cov_1hsdzkih27.b[59][1]++, (e(document).on("mousedown", ne), e(document).on("mouseup", ne), e(document).on("mouseout", ne), e(document).on("mousemove", ne))), e(window).resize(function () {
          cov_1hsdzkih27.f[47]++;
          cov_1hsdzkih27.s[120]++;
          (cov_1hsdzkih27.b[60][0]++, e(".vbox-content").length) && (cov_1hsdzkih27.b[60][1]++, setTimeout(fe(), 800));
        });
      });
    } });
}(jQuery);